import thunkActions from './thunk';
import {
  lawyerConnectionActions,
  lawyerConnectionReducer,
} from './lawyer-connection';
import { prematterActions, prematterReducer } from './prematter';
import { fileActions, fileReducer } from './file';

// we are merging the thunks with the slice actions so that we can dispatch the combination
// you cant have a reducer name match the thunk
const actions = {
  lawyerConnection: {
    ...lawyerConnectionActions,
    ...thunkActions.lawyerConnectionThunk,
  },
  prematter: {
    ...prematterActions,
    ...thunkActions.prematterThunk,
  },
  file: {
    ...fileActions,
    ...thunkActions.fileThunk,
  }
};

const reducers = {
  lawyerConnection: lawyerConnectionReducer,
  prematter: prematterReducer,
  file: fileReducer,
};

export { actions, reducers };
